/**
 * Created by USER on 18/6/25.
 */
export const ADD_PRODUCT = 'ADD_PRODUCT'; // 控制顶部栏的变化
export const ADD_PAYMENT = 'ADD_ORDER'; // 订单详细信息
export const ADD_PAYMENT_QRCODE = 'ADD_PAYMENT_QRCODE'; // 订单详细信息

export function addProduct(data) {
  return {
    type: ADD_PRODUCT,
    data
  };
}

export function paymentData(data) { // 添加支付订单信息
  return {
    type: ADD_PAYMENT,
    data
  };
}

export function paymentQrcode(data) { // 添加微信支付二维码
  return {
    type: ADD_PAYMENT_QRCODE,
    data
  };
}
